import React from 'react';
import CoachingConstants from 'coaching/CoachingConstants';
import MenuButton from 'components/MenuButtonDeprecated';
import Menu from 'components/Menu';
import MenuItem from 'components/MenuItem';
import TextWithIcon from 'components/TextWithIcon';
import TimezoneHelper from 'lib/timezones';

export type Props = {
  onSelectTimezone: (key: string) => void;
  userTimezone: string;
};

const descriptorTimezone: Record<string, string> = {
  'PDT': 'PDT (Pacific)',
  'PST': 'PST (Pacific)',
  'MST - Arizona': 'MST (Arizona)',
  'MST': 'MST (Mountain)',
  'MDT': 'MDT (Mountain)',
  'CST': 'CST (Central)',
  'CDT': 'CDT (Central)',
  'EST': 'EST (Eastern)',
  'EDT': 'EDT (Eastern)',
}

export default function TutoringSelfServeViewScheduleTimezoneSelector(props: Props) {
  const { onSelectTimezone, userTimezone } = props;
  const options = TimezoneHelper.getUSTimezonesSelectOptions().filter(
    option =>
      !(CoachingConstants.TIMEZONES_TO_EXCLUDE as ReadonlyArray<string>).includes(option.label)
  );
  const optionsMapped = options.map((option) => ({
    label: descriptorTimezone[option.label],
    value: option.value
  }));
  // options[3] will always be "America/Los_Angeles"
  const timezoneOption = options.find(o => o.value === userTimezone) ?? options[3];
  return (
    <MenuButton
      key="menu"
      size="xsmall"
      level="text"
      alignment="right"
      placement="bottom"
      data-test="schedule-timezones-button"
      menu={
        <Menu
          data-test="schedule-menu-timezones"
          onSelect={timezoneSelected => onSelectTimezone(timezoneSelected)}>
          {optionsMapped.map(option => {
            return (
              <MenuItem data-test="menu-timezones-item" key={option.value}>
                {option.label}
              </MenuItem>
            );
          })}
        </Menu>
      }>
      <TextWithIcon
        data-test="schedule-menu-timezones-selector"
        appendIcon
        icon="chevron-down"
        iconSize="small"
        size="small">
        Times shown in{' '}
        <u>
          <b>{timezoneOption?.label}</b>
        </u>
      </TextWithIcon>
    </MenuButton>
  );
}
